module.exports = __webpack_public_path__ + "img/coupon-active.1cdd9410.svg";